import React from "react";
import Plx from "react-plx";
import PropTypes from "prop-types";

const plxData = (start, startOffset, end, duration, hide) => [
    {
        start,
        end,
        startOffset,
        duration,
        properties: [
            {
                startValue: hide ? 1 : 0,
                endValue: hide ? 0 : 1,
                property: "opacity"
            }
        ]
    }
];

const AnimateOpacity = ({
    children,
    start,
    startOffset,
    end,
    duration,
    hide,
    className
}) => {
    return (
        <span>
            {start ? (
                <Plx
                    parallaxData={plxData(
                        start,
                        startOffset,
                        end,
                        duration,
                        hide
                    )}
                    className={className}
                >
                    {children}
                </Plx>
            ) : (
                children
            )}
        </span>
    );
};
AnimateOpacity.defaultProps = {
    startOffset: 0,
    style: {}
};

AnimateOpacity.propTypes = {
    children: PropTypes.node,
    start: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    startOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    end: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hide: PropTypes.bool,
    className: PropTypes.string
};

export default AnimateOpacity;



// WEBPACK FOOTER //
// ./src/components/ParallaxAnimation/AnimateOpacity.jsx